import * as Yup from "yup";

export const assistantInitialValues = {
  assistantName: "",
  firstMessage: "Hi, How can I help you today?",
  systemPrompt: "You’re a smart, friendly assistant.",
  selectedModel: "",
  selectedVoiceConfiguration: "",
  selectedChatConfiguration: "",
  agentType: "platform",
  selectedPlatformUuid: "",
  phoneId: "",
};

export const assistantValidationSchema = Yup.object({
  assistantName: Yup.string()
    .trim()
    .min(3, "Assistant name must be at least 3 characters long.")
    .required("Assistant name is required."),
  phoneId: Yup.string().nullable(),
  agentType: Yup.string(),
  selectedPlatformUuid: Yup.string().when("agentType", {
    is: (agentType) => agentType === "platform",
    then: (schema) => schema.required("A platform must be selected."),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const TTS_MODELS = [
  { value: "aura-asteria-en", label: "Aura Asteria (English)" },
  { value: "aura-luna-en", label: "Aura Luna (English)" },
  { value: "aura-stella-en", label: "Aura Stella (English)" },
  { value: "aura-athena-en", label: "Aura Athena (English)" },
];

export const STT_MODELS = [
  { value: "nova-2", label: "Nova 2 (General)" },
  { value: "nova-2-conversationalai", label: "Nova 2 (Conversational AI)" },
  { value: "nova-2-phonecall", label: "Nova 2 (Phone Call)" },
  { value: "nova-2-meeting", label: "Nova 2 (Meeting)" },
];

export const TYPES = [
  { value: "chat", label: "Chat" },
  { value: "voice", label: "Voice" },
];

export const ELEVENLABS_MODELS = [
  { value: "gpt-oss-20b", label: "GPT-OSS-20B" },
  { value: "gpt-oss-120b", label: "GPT-OSS-120B" },
  { value: "qwen3-30b-a3b", label: "Qwen3-30B-A3B" },
  { value: "glm-4.5-air", label: "GLM-4.5-Air" },
];

export const LLM_PROVIDERS = [
  { value: "openai", label: "OpenAI" },
  { value: "google", label: "Google" },
  { value: "anthropic", label: "Anthropic" },
];

export const GENERAL_LLM_MODELS = [
  {
    provider: "openai",
    options: [
      { value: "gpt-5.2", label: "GPT-5.2" },
      { value: "gpt-5.1", label: "GPT-5.1" },
      { value: "gpt-5", label: "GPT-5" },
      { value: "gpt-5-mini", label: "GPT-5 Mini" },
      { value: "gpt-5-nano", label: "GPT-5 Nano" },
      { value: "gpt-4.1", label: "GPT-4.1" },
      { value: "gpt-4.1-mini", label: "GPT-4.1 Mini" },
      { value: "gpt-4.1-nano", label: "GPT-4.1 Nano" },
      { value: "gpt-4o", label: "GPT-4o" },
      { value: "gpt-4o-mini", label: "GPT-4o Mini" },
      { value: "gpt-4-turbo", label: "GPT-4 Turbo" },
      { value: "gpt-3.5-turbo", label: "GPT-3.5 Turbo" },
    ],
  },
  {
    provider: "google",
    options: [
      { value: "gemini-2.0-flash", label: "Gemini 2.0 Flash" },
      { value: "gemini-2.0-flash-lite", label: "Gemini 2.0 Flash Lite" },
      { value: "gemini-2.5-flash-lite", label: "Gemini 2.5 Flash Lite" },
      { value: "gemini-2.5-flash", label: "Gemini 2.5 Flash" },
    ],
  },
  {
    provider: "anthropic",
    options: [
      { value: "claude-sonnet-4-5", label: "Claude Sonnet 4.5" },
      { value: "claude-sonnet-4-6", label: "Claude Sonnet 4.6" },
    ],
  },
];

export const ELEVEN_TTS_MODEL_IDS = [
  { value: "eleven_turbo_v2", label: "Eleven Turbo v2" },
  { value: "eleven_turbo_v2_5", label: "Eleven Turbo v2.5" },
  { value: "eleven_flash_v2", label: "Eleven Flash v2" },
  { value: "eleven_flash_v2_5", label: "Eleven Flash v2.5" },
  { value: "eleven_multilingual_v2", label: "Eleven Multilingual v2" },
];

export const AUDIO_FORMATS = [
  // { value: "pcm_8000", label: "PCM 8000 Hz" },
  // { value: "pcm_16000", label: "PCM 16000 Hz" },
  // { value: "pcm_22050", label: "PCM 22050 Hz" },
  // { value: "pcm_24000", label: "PCM 24000 Hz" },
  // { value: "pcm_44100", label: "PCM 44100 Hz" },
  // { value: "pcm_48000", label: "PCM 48000 Hz" },
  { value: "ulaw_8000", label: "ULaw 8000 Hz" },
];

export const TRANSCIBER_OPTIONS = [
  {
    value: "eleven_labs",
    label: "Eleven Labs",
  },
  {
    value: "openai",
    label: "OpenAI",
  },
];

export const TRANSCRIBER_MODEL_OPTIONS = [
  {
    provider: "openai",
    options: [
      { value: "whisper-1", label: "Whisper" },
      { value: "gpt-4o-transcribe", label: "GPT 4o Transcribe" },
      { value: "gpt-4o-mini-transcribe", label: "GPT 4o Mini Transcribe" },
      {
        value: "gpt-4o-transcribe-diarize",
        label: "GPT 4o Transcribe Diarize",
      },
    ],
  },
  {
    provider: "eleven_labs",
    options: [{ value: "scribe_v1", label: "Scribe V1" }],
  },
];
